import { recipeImageUri, type Recipe } from "@reciperoll/core";
import { StorageImage } from "./StorageImage";

// Fills its parent box with the recipe's image, or a placeholder glyph when the
// recipe has no photo (the web equivalent of RN's NoRecipeImageIcon). Uses
// recipeImageUri so a local pick / cached copy resolves too, then StorageImage signs
// the private-bucket path on demand. The parent owns size/rounding/overflow;
// `className` is applied to the rendered element for per-use tweaks.
export function RecipeImage({
  recipe,
  className = "",
}: {
  recipe: Recipe;
  className?: string;
}) {
  return <StorageImage stored={recipeImageUri(recipe)} className={className} />;
}
